import React from "react";

import { format } from "date-fns";

import { useTenant } from "multitenancy/config/TenantProvider";

import { BaseCard } from "components/BaseCard";
import { BaseLabel } from "components/BaseLabel";
import { StatusBadge } from "components/StatusBadge";
import { TitleSubTitleLabel } from "components/TitleSubTitleLabel";

import { ICardLeftItem } from "./interface";
import { Container, RightContainer } from "./styles";

export const CardLeftItem: React.FC<ICardLeftItem> = ({
  id,
  userName,
  title,
  subTitle,
  labelStatus,
  type,
  date,
  selected = false,
  showOnlyDate = false,
  onClick,
}) => {
  const { tenant } = useTenant();

  const showName = tenant.tenantId === "cartorio";

  return (
    <BaseCard id={id} selected={selected} onClick={onClick}>
      <Container>
        <div style={{ width: "170px" }}>
          <TitleSubTitleLabel
            childrenTitle={title}
            childrenSubTitle={subTitle}
            marginBetweenTitleAndSubTitle="0"
            childrenThirdTitle={showName ? userName : ""}
            marginBottom="0"
            marginLeft="0"
            marginTop="0"
            marginRight="0"
            height={showName ? "80px" : "50px"}
          />
        </div>
        <RightContainer style={{ height: showName ? "80px" : "50px" }}>
          <BaseLabel
            fontWeight="600"
            marginBottom="20px"
            marginLeft="0px"
            marginRight="0px"
            marginTop="0px"
          >
            {showOnlyDate
              ? format(date, "dd/MM/yyyy")
              : format(date, "dd/MM/yyyy HH:mm")}
          </BaseLabel>
          <StatusBadge id="status_badge" label={labelStatus} type={type} />
        </RightContainer>
      </Container>
    </BaseCard>
  );
};
